import {call, put} from "redux-saga/effects";
import * as api from "services/api";
import {getErrorFromMessage} from "services/utils/utils";
import {errorThreadsFavoritesGet, successThreadsFavoritesGet} from "features/pages/threads/favorite/reducer";

export function* getFavoritesThreadsSaga() {
    try {
        const data = yield call([api, api.getThreadsFavoritesApi]);
        yield put(successThreadsFavoritesGet(data));
    } catch (e) {
        yield put(errorThreadsFavoritesGet(getErrorFromMessage(e)));
    }
}